import ToastShiftClashNotice from "@/components/rota/shift/ToastShiftClashNotice.vue";

/**
 * Customise toast attributes
 * @param {string} event Toast event e.g. clearAll, success, info, danger, etc...
 * @param {string} message Message to "toast"
 * @param {object} data Object of extra data passed to the toast
 * @returns {object} Empty object or extra attributes to configure the toast
 * @see https://github.com/Maronato/vue-toastification?tab=readme-ov-file#api
 */
export default function extendToast(event, message, data) {
  if (data?.context === "shift-clash") {
    return {
      content: {
        component: ToastShiftClashNotice,
        props: {
          message: data,
        },
      },
      position: "top-right",
      timeout: false,
      closeOnClick: false,
    };
  }
  return {};
}
